/* libs */
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";

/* components */
import Page from "../../shared/Page";
import GridFormSwitcher from "../../shared/GridFormSwitcher";
import Grid from "../../shared/Grid";
import IntegrationFormWrapper from "./IntegrationFormWrapper";

/* helpers */
import * as controlPanelActions from "../../../actions/controlPanelActions";
import * as globalActions from "../../../actions/globalActions";
import * as integrationActions from "../../../actions/integrationActions";
import * as modulesActions from "../../../actions/modulesActions";
import * as oauthActions from "../../../actions/oauthActions";

class IntegrationsPage extends Component {
	constructor(props) {
		super(props);
		this.expId = props.match.params.expId;
		this.appId = "";
		this.appKey = this.props.match.params.appKey;
		if (this.props.apps) {
			let app = this.props.apps.find(app => {
				return app.key === this.appKey;
			});
			this.appId = app ? app.id : "";
		}
		this.state = {
			hasFormApi: false,
			formApi: null,
		};
	}

	componentDidMount() {
		const { modulesActions, integrationActions } = this.props;
		integrationActions.loadIntegrations(this.appKey);
		modulesActions.loadModules();
	}

	getAppId = () => {
		let appId = "";
		if (this.props.apps) {
			let app = this.props.apps.find(app => {
				return app.key === this.appKey;
			});
			appId = app ? app.id : "";
		}
		return appId;
	};

	getFormApi = formApi => {
		this.setState({ formApi, hasFormApi: true });
	};

	clearFormApi = () => {
		this.setState({ formApi: null, hasFormApi: false });
	};

	reloadIntegrations = () => {
		const { history, integrationActions, oauthActions } = this.props;
		integrationActions.loadIntegrations(this.appKey);
		oauthActions.canRefresh();
		history.push(`/apps/${this.appKey}/integrations`);
	};

	logError = () => {};

	createItem = (values, submitHandler) => {
		const {
			globalActions,
			modules: { modules },
		} = this.props;

		const data = {
			...values,
			appId: this.getAppId(),
		};
		const module = modules.find(m => m.id === values.moduleId);

		if (module && module.type === "integration") {
			globalActions.createItem(data, "/oauth", this.reloadIntegrations, this.logError, submitHandler);
		} else {
			globalActions.createItem(data, "/integrations", this.reloadIntegrations, this.logError, submitHandler);
		}
	};

	updateItem = (values, submitHandler, itemId) => {
		const {
			globalActions,
			modules: { modules },
			oauthActions,
		} = this.props;

		const module = modules.find(m => m.id === values.moduleId);

		if (module && module.type === "integration") {
			globalActions.updateItem(values, `/oauth/${itemId}`, this.reloadIntegrations, this.logError, submitHandler);
		} else {
			globalActions.updateItem(
				values,
				`/integrations/${itemId}`,
				this.reloadIntegrations,
				this.logError,
				submitHandler
			);
		}
	};

	copyItem = (values, submitHandler) => {
		const {
			globalActions,
			modules: { modules },
		} = this.props;

		const data = {
			...values,
			appId: this.getAppId(),
		};
		const module = modules.find(m => m.id === values.moduleId);

		if (module && module.type === "integration") {
			globalActions.createItem(data, "/oauth", this.reloadIntegrations, this.logError, submitHandler);
		} else {
			globalActions.createItem(data, "/integrations", this.reloadIntegrations, this.logError, submitHandler);
		}
	};

	deleteItem = (id, name) => {
		const {
			integrationActions,
			globalActions,
			integrations: { integrations },
		} = this.props;

		const integration = integrations.find(i => i.id === id);

		const onSuccess = () => {
			integrationActions.loadIntegrations(this.appKey);
		};

		if (integration && integration.moduleType === "OAuthIntegration") {
			globalActions.deleteItem(`/oauth/${id}`, onSuccess, this.logError, name);
		} else {
			globalActions.deleteItem(`/integrations/${id}`, onSuccess, this.logError, name);
		}
	};

	loadIntegration = integrationId => {
		const { integrationActions } = this.props;
		integrationActions.loadIntegration(integrationId);
	};

	showLoading = () => {
		this.props.controlPanelActions.showLoading();
	};

	hideLoading = () => {
		this.props.controlPanelActions.hideLoading();
	};

	/* populate grid */

	renderGrid = () => {
		const { integrations } = this.props.integrations;

		return (
			<div>
				{integrations ? (
					<Grid
						defaultText="Create your first integration..."
						columnNames={["Integration"]}
						singleItemName="Integration"
						pluralItemName="Integrations"
						items={integrations}
						delete={this.deleteItem}
					/>
				) : (
					<h1>Loading...</h1>
				)}
			</div>
		);
	};

	render() {
		const { integrations, modules } = this.props;
		return (
			<Page title="Pages">
				{integrations && modules ? (
					<GridFormSwitcher
						objectKey="Pages"
						singleItemName="Page"
						pluralItemName="Pages"
						RenderCopy={IntegrationFormWrapper}
						RenderEdit={IntegrationFormWrapper}
						RenderNew={IntegrationFormWrapper}
						items={integrations.integrations}
						renderGrid={this.renderGrid}
						createItem={this.createItem}
						updateItem={this.updateItem}
						copyItem={this.copyItem}
						modules={modules}
						getSingleItem={this.loadPage}
						getFormApi={this.getFormApi}
						formApi={this.state.formApi}
						hasFormApi={this.state.hasFormApi}
						appKey={this.appKey}
						apps={this.props.apps}
						showLoading={this.showLoading}
						hideLoading={this.hideLoading}
						clearFormApi={this.clearFormApi}
					/>
				) : (
					<h1>Loading...</h1>
				)}
			</Page>
		);
	}
}

const mapStateToProps = state => ({
	apps: state.apps.apps,
	integrations: state.integrations,
	modules: state.modules,
	oauth: state.oauth,
});

const mapDispatchToProps = dispatch => ({
	controlPanelActions: bindActionCreators(controlPanelActions, dispatch),
	globalActions: bindActionCreators(globalActions, dispatch),
	integrationActions: bindActionCreators(integrationActions, dispatch),
	modulesActions: bindActionCreators(modulesActions, dispatch),
	oauthActions: bindActionCreators(oauthActions, dispatch),
});

IntegrationsPage.propTypes = {
	apps: PropTypes.array,
	controlPanelActions: PropTypes.object,
	globalActions: PropTypes.object,
	history: PropTypes.object,
	integrationActions: PropTypes.object,
	integrations: PropTypes.object,
	match: PropTypes.object,
	modules: PropTypes.object,
	modulesActions: PropTypes.object,
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(IntegrationsPage);
